/**
 * Zeitbezug von Altbelegen. Preise steigen: Wer 50 Belege aus fünf Jahren
 * hochlädt, hat 2022 die Facharbeiterstunde für 55 € und 2026 für 75 €
 * abgerechnet. Ein Median über alles wäre veraltet — maßgeblich ist, was der
 * Betrieb zuletzt verlangt hat.
 */

/** Belegdatum aus "TT.MM.JJJJ" oder ISO — null, wenn nicht lesbar. */
export function belegDatum(text) {
    const s = String(text || '');
    let m = s.match(/(\d{1,2})\.(\d{1,2})\.(\d{4})/);
    if (m) return new Date(Date.UTC(+m[3], +m[2] - 1, +m[1]));
    m = s.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    return null;
}

const JAHR_MS = 365 * 24 * 3600 * 1000;

/**
 * Wählt die aktuellen Werte: alles aus den 12 Monaten vor `stichtag` (dem
 * jüngsten Beleg insgesamt). Gibt es dort weniger als `mindestens` Werte,
 * die `mindestens` jüngsten. Werte ohne Datum zählen nur, wenn keiner eins hat.
 * @param {Array<{ wert: number, datum: Date|null }>} werte
 */
export function aktuelleWerte(werte, stichtag, mindestens = 3) {
    const datiert = werte.filter((w) => w.datum);
    if (!stichtag || datiert.length === 0) return werte;
    const grenze = stichtag.getTime() - JAHR_MS;
    const jung = datiert.filter((w) => w.datum.getTime() >= grenze);
    if (jung.length >= mindestens) return jung;
    return [...datiert].sort((a, b) => b.datum - a.datum).slice(0, mindestens);
}

/** Jüngstes Belegdatum über alle Dokumente. */
export function juengstesDatum(daten) {
    const ok = daten.filter(Boolean);
    return ok.length ? new Date(Math.max(...ok.map((d) => d.getTime()))) : null;
}
